import { useCallback, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { FilterAlt } from '@mui/icons-material';
import { Button, IconButton } from '@mui/material';

import { Property } from './models/Property';
import FilterMenu from './FilterMenu';

interface FilterButtonProps {
  properties: Array<Property>;
  onClickProperty?: (property: Property) => void;
}

const FilterButton = ({ properties, onClickProperty }: FilterButtonProps) => {
  const { formatMessage } = useIntl();
  const [filterMenuElement, setFilterMenuElement] = useState<HTMLElement | null>(null);

  const handleClickButton = useCallback((e) => {
    setFilterMenuElement(e.currentTarget);
  }, []);

  const handleCloseFilterMenu = useCallback(() => {
    setFilterMenuElement(null);
  }, []);

  const handleClickProperty = useCallback(
    (property: Property) => {
      setFilterMenuElement(null);
      onClickProperty?.(property);
    },
    [onClickProperty]
  );

  return (
    <>
      <IconButton
        color="secondary"
        onClick={handleClickButton}
        sx={{ display: { xs: 'inline-flex', sm: 'none' } }}
      >
        <FilterAlt titleAccess={formatMessage({ defaultMessage: 'Filter' })} />
      </IconButton>
      <Button
        variant="outlined"
        color="secondary"
        onClick={handleClickButton}
        startIcon={<FilterAlt />}
        sx={{ display: { xs: 'none', sm: 'inline-flex' } }}
      >
        <FormattedMessage defaultMessage="Filter" />
      </Button>
      <FilterMenu
        anchorEl={filterMenuElement}
        anchorOrigin={{
          horizontal: 'left',
          vertical: 48,
        }}
        properties={properties}
        onClick={handleClickProperty}
        onClose={handleCloseFilterMenu}
      />
    </>
  );
};

export { FilterButtonProps };
export default FilterButton;
